export default "__VITE_ASSET__UHChd5ff__"